export const selectorSubTabs = {
  methodRequest: 'methodRequest',
  variant: 'variant',
}

export const mockDeliveryMethods = [
  {
    id: 'preview-1',
    type: 'customerpickup',
    name: null,
    carrier_service: { is_connected: false, logo_url: null, name: '' },
    total_fee: '15.00',
    extra_fee: '1.00',
    base_extra_fee: '3.00',
    currency: 'EUR',
    extra_fee_type: 'per_returned_item',
    extra_fee_included_items: 2,
    carbon_offset_fee: null,
    non_charged_fee: null,
    visibility: 'public',
  },
]

export const mockRefundOption = {
  value: 'store_credit',
  label: 'Crédito en tienda',
  helperText:
    'Recibe YA un código para volver a comprar en Fashion Store, con hasta un 10% extra de regalo sobre tu devolución.',
  extraCredit: '+10%',
  feeAmount: '1,00',
  refundAmount: '252,40',
}

export const subTabToColorGroup = {
  [selectorSubTabs.methodRequest]: 'splitButtonColors',
  [selectorSubTabs.variant]: 'variantButtonColors',
}
